export default __webpack_public_path__ + "static/media/ob-01.b0257c88.svg";